export default {
  methods: {
    formatPrice (price) {
      return parseFloat(price).toFixed(2).replace('.00', '')
    }
  }
}
